import { FaHome, FaClock, FaCog, FaHistory } from "react-icons/fa";
import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../../../assets/css/Drivers/general/DriverBottomnav.css";
import AppContext from "../../../context/AppContext";

const DriverBottomnav = ({ screenName }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setAuthToken } = useContext(AppContext);

  const isActive = (path) => location.pathname === path;

  // Handle navigation
  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <nav className="driver-dashboard__bottom-nav">
      <button
        className={`driver-dashboard__nav-btn ${isActive("/driver-dashboard") ? "driver-dashboard__nav-btn--active" : ""}`}
        onClick={() => handleNavigation("/driver-dashboard")}
      >
        <FaHome size={20} />
        <span>Home</span>
      </button>

      <button
        className={`driver-dashboard__nav-btn ${isActive("/driver-active-rides") ? "driver-dashboard__nav-btn--active" : ""}`}
        onClick={() => handleNavigation("/driver-active-rides")}
      >
        <FaClock size={20} />
        <span>Active Ride</span>
      </button>

      <button
        className={`driver-dashboard__nav-btn ${isActive("/driver-myrides") ? "driver-dashboard__nav-btn--active" : ""}`}
        onClick={() => handleNavigation("/driver-myrides")}
      >
        <FaHistory size={20} />
        <span>My Rides</span>
      </button>

      <button
        className={`driver-dashboard__nav-btn ${isActive("/driver-setting") ? "driver-dashboard__nav-btn--active" : ""}`}
        onClick={() => handleNavigation("/driver-setting")}
      >
        <FaCog size={20} />
        <span>Setting</span>
      </button>
    </nav>
  );
};

export default DriverBottomnav;
